// extracted by mini-css-extract-plugin
export var categoryIcon = "_dd-5";
export var connectorContainer = "_dd-1";
export var connectorLine = "_dd-0";
export var minHeight0 = "_dd-6";
export var relativeUnitValueSelector = "_dd-2";
export var trifoldSelectorBody = "_dd-4";
export var trifoldSelectorList = "_dd-3";